module.exports = __webpack_public_path__ + "img/procure-supplies-icon.1e05540a.svg";